enum Permissions {
  ACCOUNT = 'CPANEL_ACCOUNT',
  ACCOUNT_ADMIN = 'CPANEL_ACCOUNT_ADMIN',
  ACCOUNT_AUDITOR = 'CPANEL_ACCOUNT_AUDITOR',
  ORGANIZATION_AUDITOR = 'CPANEL_ORGANIZATION_AUDITOR',
  CUSTOMER_AUDITOR = 'CPANEL_CUSTOMER_AUDITOR',
  ACCOUNT_ANALYTICS = 'CPANEL_ACCOUNT_ANALYTICS',
  ACCOUNT_ANONYMOUS_ACCESS_PROVIDERS = 'CPANEL_ACCOUNT_ANONYMOUS_ACCESS_PROVIDERS',
  ACCOUNT_API_AUTHORIZATION = 'CPANEL_ACCOUNT_API_AUTHORIZATION',
  ACCOUNT_APPLICATION = 'CPANEL_ACCOUNT_APPLICATION',
  ACCOUNT_AUDIT_TRAIL = 'CPANEL_ACCOUNT_AUDIT_TRAIL',
  ACCOUNT_AUDIT_TRAILS = 'CPANEL_ACCOUNT_AUDIT_TRAILS',
  ACCOUNT_AUTHENTICATION_SETTINGS = 'CPANEL_ACCOUNT_AUTHENTICATION_SETTINGS',
  ACCOUNT_AUTHORIZATION_RULE = 'CPANEL_ACCOUNT_AUTHORIZATION_RULE',
  ACCOUNT_AUTHORIZATION_RULES = 'CPANEL_ACCOUNT_AUTHORIZATION_RULES',
  ACCOUNT_AVAILABILITY_ZONES = 'CPANEL_ACCOUNT_AVAILABILITY_ZONES',
  ACCOUNT_CAPACITY = 'CPANEL_ACCOUNT_CAPACITY',
  ACCOUNT_DISK_VOLUME_USAGE = 'CPANEL_ACCOUNT_DISK_VOLUME_USAGE',
  ACCOUNT_DOMAIN_JOIN = 'CPANEL_ACCOUNT_DOMAIN_JOIN',
  ACCOUNT_ELASTICITY = 'CPANEL_ACCOUNT_ELASTICITY',
  ACCOUNT_GOOGLE_AUTHORIZATION = 'CPANEL_ACCOUNT_GOOGLE_AUTHORIZATION',
  ACCOUNT_LIST_API_AUTHORIZATION = 'CPANEL_ACCOUNT_LIST_API_AUTHORIZATION',
  ACCOUNT_MY_NUTANIX_AUTHORIZATION = 'CPANEL_ACCOUNT_MY_NUTANIX_AUTHORIZATION',
  ACCOUNT_NOTIFICATION_CENTER = 'CPANEL_ACCOUNT_NOTIFICATION_CENTER',
  ACCOUNT_NOTIFICATION_CENTER_SETTINGS = 'CPANEL_ACCOUNT_NOTIFICATION_CENTER_SETTINGS',
  ACCOUNT_POOL = 'CPANEL_ACCOUNT_POOL',
  ACCOUNT_POOL_BACKUP = 'CPANEL_ACCOUNT_POOL_BACKUP',
  ACCOUNT_PUBLISH_TASKS = 'CPANEL_ACCOUNT_PUBLISH_TASKS',
  ACCOUNT_ROLE_SCOPES = 'CPANEL_ACCOUNT_ROLE_SCOPES',
  ACCOUNT_ROLES = 'CPANEL_ACCOUNT_ROLES',
  ACCOUNT_SAML_PROVIDERS = 'CPANEL_ACCOUNT_SAML_PROVIDERS',
  ACCOUNT_SANDBOX_STATUS = 'CPANEL_ACCOUNT_SANDBOX_STATUS',
  ACCOUNT_SERVERS = 'CPANEL_ACCOUNT_SERVERS',
  ACCOUNT_STATUS = 'CPANEL_ACCOUNT_STATUS',
  ACCOUNT_USAGE = 'CPANEL_ACCOUNT_USAGE',
  ACCOUNT_USER = 'CPANEL_ACCOUNT_USER',
  ACCOUNT_USER_ACTIVITY = 'CPANEL_ACCOUNT_USER_ACTIVITY',
  ACCOUNT_USER_VOLUMES = 'CPANEL_ACCOUNT_USER_VOLUMES',
  ACCOUNT_USER_VOLUMES_BACKUPS = 'CPANEL_ACCOUNT_USER_VOLUMES_BACKUPS',
  ACCOUNT_USERS = 'CPANEL_ACCOUNT_USERS',
  ACCOUNT_DISASTER_RECOVERY_SETTINGS = 'CPANEL_DISASTER_RECOVERY_SETTINGS',
  ACCOUNT_CONFIGURE_DISASTER_RECOVERY_SETTINGS = 'CPANEL_MUTATION_CONFIGURE_DISASTER_RECOVERY_SETTINGS',
  ACCOUNT_UPDATE_DISASTER_RECOVERY_SETTINGS = 'CPANEL_MUTATION_UPDATE_DISASTER_RECOVERY_SETTINGS',
  ACCOUNT_DELETE_DISASTER_RECOVERY_SETTINGS = 'CPANEL_MUTATION_DELETE_DISASTER_RECOVERY_SETTINGS',
  ACKNOWLEDGE_NOTIFICATION = 'CPANEL_ACKNOWLEDGE_NOTIFICATION',
  ACTIVATE_CUSTOMER = 'CPANEL_MUTATION_ACTIVATE_CUSTOMER',
  ACTIVATE_CUSTOMER_CLOUD_SERVICES = 'CPANEL_MUTATION_ACTIVATE_CUSTOMER_CLOUD_SERVICES',
  ACTIVATE_ORGANIZATION = 'CPANEL_MUTATION_ACTIVATE_ORGANIZATION',
  ACTIVATE_ORGANIZATION_CLOUD_SERVICES = 'CPANEL_MUTATION_ACTIVATE_ORGANIZATION_CLOUD_SERVICES',
  ADD_DATACENTERS_TO_CUSTOMER_CLOUD_SERVICES = 'CPANEL_MUTATION_ADD_DATACENTERS_TO_CUSTOMER_CLOUD_SERVICES',
  ADD_DATACENTERS_TO_ORGANIZATION_CLOUD_SERVICES = 'CPANEL_MUTATION_ADD_DATACENTERS_TO_ORGANIZATION_CLOUD_SERVICES',
  ADD_INSTANCE_TYPE_CUSTOMER_CLOUD_SERVICES = 'CPANEL_MUTATION_ADD_INSTANCE_TYPE_CUSTOMER_CLOUD_SERVICES',
  ADD_INSTANCE_TYPE_ORGANIZATION_CLOUD_SERVICES = 'CPANEL_MUTATION_ADD_INSTANCE_TYPE_ORGANIZATION_CLOUD_SERVICES',
  ADD_SAML_IDENTITY_PROVIDER = 'CPANEL_MUTATION_ADD_SAML_IDENTITY_PROVIDER',
  ADD_TERMS_OF_SERVICE = 'CPANEL_MUTATION_ADD_TERMS_OF_SERVICE',
  ADMIN = 'CPANEL_ADMIN',
  CANCEL_TASK = 'CPANEL_CANCEL_TASK',
  CHANGE_CLOUD_SERVICE_CREDENTIALS = 'CPANEL_MUTATION_CHANGE_CLOUD_SERVICE_CREDENTIALS',
  CHECK_CLUSTER_CAPACITY_CHANGE_LIMITS = 'CPANEL_MUTATION_CHECK_CLUSTER_CAPACITY_CHANGE_LIMITS',
  CLOUD_PROVIDERS = 'CPANEL_CLOUD_PROVIDERS',
  CLOUD_SERVICE_TYPES = 'CPANEL_CLOUD_SERVICE_TYPES',
  CLUSTER = 'CPANEL_CLUSTER',
  CLUSTER_ACCESS_POLICY = 'CPANEL_CLUSTER_ACCESS_POLICY',
  CLUSTER_AOS_TIER = 'CPANEL_CLUSTER_AOS_TIER',
  CLUSTER_HOST = 'CPANEL_CLUSTER_HOST',
  CONDEMN_NODE = 'CPANEL_MUTATION_CONDEMN_NODE',
  CONFIGURE_CUSTOMER_CLOUD_SERVICES = 'CPANEL_MUTATION_CONFIGURE_CUSTOMER_CLOUD_SERVICES',
  CONFIGURE_ORGANIZATION_CLOUD_SERVICES = 'CPANEL_MUTATION_CONFIGURE_ORGANIZATION_CLOUD_SERVICES',
  CPANEL_ACCOUNT_SUPPORT_SETTINGS = 'CPANEL_ACCOUNT_SUPPORT_SETTINGS',
  CPANEL_ACCOUNT_PROVISION_PRODUCTION_INSTANCES = 'CPANEL_ACCOUNT_PROVISION_PRODUCTION_INSTANCES',
  CPANEL_CUSTOMER_SUPPORT_SETTINGS = 'CPANEL_CUSTOMER_SUPPORT_SETTINGS',
  CPANEL_MUTATION_UPDATE_ACCOUNT_NOTIFICATION_CENTER_SETTINGS = 'CPANEL_MUTATION_UPDATE_ACCOUNT_NOTIFICATION_CENTER_SETTINGS',
  CPANEL_MUTATION_UPDATE_ACCOUNT_SUPPORT_SETTINGS = 'CPANEL_MUTATION_UPDATE_ACCOUNT_SUPPORT_SETTINGS',
  CPANEL_MUTATION_UPDATE_CUSTOMER_NOTIFICATION_CENTER_SETTINGS = 'CPANEL_MUTATION_UPDATE_CUSTOMER_NOTIFICATION_CENTER_SETTINGS',
  CPANEL_MUTATION_UPDATE_CUSTOMER_SUPPORT_SETTINGS = 'CPANEL_MUTATION_UPDATE_CUSTOMER_SUPPORT_SETTINGS',
  CPANEL_MUTATION_UPDATE_ORGANIZATION_NOTIFICATION_CENTER_SETTINGS = 'CPANEL_MUTATION_UPDATE_ORGANIZATION_NOTIFICATION_CENTER_SETTINGS',
  CPANEL_MUTATION_UPDATE_ORGANIZATION_SUPPORT_SETTINGS = 'CPANEL_MUTATION_UPDATE_ORGANIZATION_SUPPORT_SETTINGS',
  CPANEL_ORGANIZATION_SUPPORT_SETTINGS = 'CPANEL_ORGANIZATION_SUPPORT_SETTINGS',
  CPANEL_REQUEST_ACCOUNT_ACCESS = 'CPANEL_REQUEST_ACCOUNT_ACCESS',
  CPANEL_REQUEST_CUSTOMER_ACCESS = 'CPANEL_REQUEST_CUSTOMER_ACCESS',
  CPANEL_REQUEST_ORGANIZATION_ACCESS = 'CPANEL_REQUEST_ORGANIZATION_ACCESS',
  CPANEL_REQUEST_ACCOUNT_AUDITOR_ACCESS = 'CPANEL_REQUEST_ACCOUNT_AUDITOR_ACCESS',
  CPANEL_REQUEST_CUSTOMER_AUDITOR_ACCESS = 'CPANEL_REQUEST_CUSTOMER_AUDITOR_ACCESS',
  CPANEL_REQUEST_ORGANIZATION_AUDITOR_ACCESS = 'CPANEL_REQUEST_ORGANIZATION_AUDITOR_ACCESS',
  CREATE_ANONYMOUS_ACCESS_PROVIDER = 'CREATE_MUTATION_ANONYMOUS_ACCESS_PROVIDER',
  CREATE_ANONYMOUS_ACCESS_TOKEN = 'CREATE_ANONYMOUS_ACCESS_TOKEN',
  CREATE_API_AUTHORIZATION = 'CPANEL_MUTATION_CREATE_API_AUTHORIZATION',
  CREATE_API_CREDENTIALS = 'CPANEL_MUTATION_CREATE_API_CREDENTIALS',
  CREATE_AUTHORIZATION_RULE = 'CPANEL_MUTATION_CREATE_AUTHORIZATION_RULE',
  CREATE_CLOUD_SERVICE = 'CPANEL_MUTATION_CREATE_CLOUD_SERVICE',
  CREATE_CLOUD_SERVICE_KEY = 'CPANEL_MUTATION_CREATE_CLOUD_SERVICE_KEY',
  CREATE_CLUSTER = 'CPANEL_MUTATION_CREATE_CLUSTER',
  CREATE_CLUSTER_TOOLS = 'CPANEL_CREATE_CLUSTER_TOOLS',
  CREATE_CUSTOMER = 'CPANEL_MUTATION_CREATE_CUSTOMER',
  CREATE_GOOGLE_AUTHORIZATION_RULE = 'CPANEL_MUTATION_CREATE_GOOGLE_AUTHORIZATION_RULE',
  CREATE_ORGANIZATION = 'CPANEL_MUTATION_CREATE_ORGANIZATION',
  CREATE_PERSISTENT_DESKTOP_BACKUP = 'CPANEL_MUTATION_CREATE_PERSISTENT_DESKTOP_BACKUP',
  CUSTOMER = 'CPANEL_CUSTOMER',
  CUSTOMER_ACCOUNTS = 'CPANEL_CUSTOMER_ACCOUNTS',
  CUSTOMER_ADMIN = 'CPANEL_CUSTOMER_ADMIN',
  CUSTOMER_ANALYTICS = 'CPANEL_CUSTOMER_ANALYTICS',
  CUSTOMER_ANONYMOUS_ACCESS_PROVIDERS = 'CPANEL_CUSTOMER_ANONYMOUS_ACCESS_PROVIDERS',
  CUSTOMER_API_AUTHORIZATION = 'CPANEL_CUSTOMER_API_AUTHORIZATION',
  CUSTOMER_AUDIT_TRAIL = 'CPANEL_CUSTOMER_AUDIT_TRAIL',
  CUSTOMER_AUDIT_TRAILS = 'CPANEL_CUSTOMER_AUDIT_TRAILS',
  CUSTOMER_AUTHENTICATION_SETTINGS = 'CPANEL_CUSTOMER_AUTHENTICATION_SETTINGS',
  CUSTOMER_AUTHORIZATION_RULE = 'CPANEL_CUSTOMER_AUTHORIZATION_RULE',
  CUSTOMER_AUTHORIZATION_RULES = 'CPANEL_CUSTOMER_AUTHORIZATION_RULES',
  CUSTOMER_AVAILABLE_APPLICATIONS = 'CPANEL_CUSTOMER_AVAILABLE_APPLICATIONS',
  CUSTOMER_CLOUD_SERVICES = 'CPANEL_CUSTOMER_CLOUD_SERVICES',
  CUSTOMER_CLUSTER_USAGE = 'CPANEL_CUSTOMER_CLUSTER_USAGE',
  CUSTOMER_DISK_VOLUME_USAGE = 'CPANEL_CUSTOMER_DISK_VOLUME_USAGE',
  CUSTOMER_EXTRA_FEATURES = 'CPANEL_CUSTOMER_EXTRA_FEATURES',
  CUSTOMER_GOOGLE_AUTHORIZATION = 'CPANEL_CUSTOMER_GOOGLE_AUTHORIZATION',
  CUSTOMER_LIMITS = 'CPANEL_CUSTOMER_LIMITS',
  CUSTOMER_LIST_API_AUTHORIZATION = 'CPANEL_CUSTOMER_LIST_API_AUTHORIZATION',
  CUSTOMER_MY_NUTANIX_AUTHORIZATION = 'CPANEL_CUSTOMER_MY_NUTANIX_AUTHORIZATION',
  CUSTOMER_NOTIFICATION_CENTER = 'CPANEL_CUSTOMER_NOTIFICATION_CENTER',
  CUSTOMER_NOTIFICATION_CENTER_SETTINGS = 'CPANEL_CUSTOMER_NOTIFICATION_CENTER_SETTINGS',
  CUSTOMER_ROLE_SCOPES = 'CPANEL_CUSTOMER_ROLE_SCOPES',
  CUSTOMER_ROLES = 'CPANEL_CUSTOMER_ROLES',
  CUSTOMER_SAML_PROVIDERS = 'CPANEL_CUSTOMER_SAML_PROVIDERS',
  CUSTOMER_SUPERADMIN = 'CPANEL_CUSTOMER_SUPERADMIN',
  CUSTOMER_SUPPORT_SETTINGS = 'CPANEL_CUSTOMER_SUPPORT_SETTINGS',
  CUSTOMER_USAGE = 'CPANEL_CUSTOMER_USAGE',
  CUSTOMER_USER = 'CPANEL_CUSTOMER_USER',
  CUSTOMER_USER_ACTIVITY = 'CPANEL_CUSTOMER_USER_ACTIVITY',
  CUSTOMER_USERS = 'CPANEL_CUSTOMER_USERS',
  DASHBOARD = 'CPANEL_DASHBOARD',
  DATA_CENTER = 'CPANEL_DATA_CENTER',
  DATACENTER_CLOUD_INFO = 'CPANEL_DATACENTER_CLOUD_INFO',
  DATACENTER_INSTANCE_FAMILIES = 'CPANEL_DATACENTER_INSTANCE_FAMILIES',
  DEACTIVATE_ACCOUNT = 'CPANEL_MUTATION_DEACTIVATE_ACCOUNT',
  DEACTIVATE_CUSTOMER = 'CPANEL_MUTATION_DEACTIVATE_CUSTOMER',
  DEACTIVATE_CUSTOMER_CLOUD_SERVICES = 'CPANEL_MUTATION_DEACTIVATE_CUSTOMER_CLOUD_SERVICES',
  DEACTIVATE_ORGANIZATION = 'CPANEL_MUTATION_DEACTIVATE_ORGANIZATION',
  DEACTIVATE_ORGANIZATION_CLOUD_SERVICES = 'CPANEL_MUTATION_DEACTIVATE_ORGANIZATION_CLOUD_SERVICES',
  DELETE_ANONYMOUS_ACCESS_PROVIDER = 'DELETE_MUTATION_ANONYMOUS_ACCESS_PROVIDER',
  DELETE_API_AUTHORIZATION = 'CPANEL_MUTATION_DELETE_API_AUTHORIZATION',
  DELETE_API_CREDENTIAL = 'CPANEL_MUTATION_DELETE_API_CREDENTIAL',
  DELETE_API_CREDENTIALS = 'CPANEL_MUTATION_DELETE_API_CREDENTIALS',
  DELETE_APPLICATION = 'CPANEL_MUTATION_DELETE_APPLICATION',
  DELETE_APPLICATION_ON_PUBLISH = 'CPANEL_MUTATION_DELETE_APPLICATION_ON_PUBLISH',
  DELETE_AUTHORIZATION_RULE = 'CPANEL_MUTATION_DELETE_AUTHORIZATION_RULE',
  DELETE_BACKUP = 'CPANEL_MUTATION_DELETE_BACKUP',
  DELETE_CLUSTER_TOOLS = 'CPANEL_DELETE_CLUSTER_TOOLS',
  DELETE_GOOGLE_AUTHORIZATION_RULE = 'CPANEL_MUTATION_DELETE_GOOGLE_AUTHORIZATION_RULE',
  DELETE_PERSISTENT_DESKTOP_BACKUP = 'CPANEL_MUTATION_DELETE_PERSISTENT_DESKTOP_BACKUP',
  DELETE_SAML_IDENTITY_PROVIDER = 'CPANEL_MUTATION_DELETE_SAML_IDENTITY_PROVIDER',
  DELETE_USER_VOLUME = 'CPANEL_MUTATION_DELETE_USER_VOLUME',
  AVAILABLE_PRISM_CENTRALS = 'CPANEL_AVAILABLE_PRISM_CENTRALS',
  DISMISS_ACCOUNT_ALERT = 'CPANEL_MUTATION_DISMISS_ACCOUNT_ALERT',
  DISMISS_ALERT = 'CPANEL_MUTATION_DISMISS_ALERT',
  DISMISS_CLOUD_SERVICE_ALERT = 'CPANEL_MUTATION_DISMISS_CLOUD_SERVICE_ALERT',
  DISMISS_PENDING_REQUEST = 'CPANEL_MUTATION_DISMISS_PENDING_REQUEST',
  DISMISS_FRAME_TRAINING_NOTIFICATION = 'CPANEL_MUTATION_DISMISS_FRAME_TRAINING_NOTIFICATION',
  EDIT_USER = 'CPANEL_MUTATION_EDIT_USER',
  ENABLE_CUSTOMER_CLOUD_SERVICES = 'CPANEL_MUTATION_ENABLE_CUSTOMER_CLOUD_SERVICES',
  ENABLE_ORGANIZATION_CLOUD_SERVICES = 'CPANEL_MUTATION_ENABLE_ORGANIZATION_CLOUD_SERVICES',
  GATEWAY = 'CPANEL_GATEWAY',
  GET_CLUSTER_TOOL_PACKAGE = 'CPANEL_GET_CLUSTER_TOOL_PACKAGE',
  GET_CLUSTER_TOOLS = 'CPANEL_GET_CLUSTER_TOOLS',
  HIBERNATE_CLUSTER = 'CPANEL_MUTATION_HIBERNATE_CLUSTER',
  IMAGE_FAMILIES = 'CPANEL_IMAGE_FAMILIES',
  INSTANCE_FAMILIES = 'CPANEL_INSTANCE_FAMILIES',
  INSTANCE_TYPES = 'CPANEL_INSTANCE_TYPES',
  INVITE_USER = 'CPANEL_MUTATION_INVITE_USER',
  LIST_AHV_CLUSTER_RESOURCES_CUSTOMER_CLOUD_SERVICES = 'CPANEL_LIST_AHV_CLUSTER_RESOURCES_CUSTOMER_CLOUD_SERVICES',
  LIST_AHV_CLUSTER_RESOURCES_ORGANIZATION_CLOUD_SERVICES = 'CPANEL_LIST_AHV_CLUSTER_RESOURCES_ORGANIZATION_CLOUD_SERVICES',
  LIST_ALERTS = 'CPANEL_LIST_ALERTS',
  LIST_CLOUD_SERVICE_KEYS = 'CPANEL_LIST_CLOUD_SERVICE_KEYS',
  LIST_CLUSTER_HOSTS = 'CPANEL_LIST_CLUSTER_HOSTS',
  LIST_CLUSTER_TOOL_PACKAGES = 'CPANEL_LIST_CLUSTER_TOOL_PACKAGES',
  LIST_CLUSTER_TOOLS = 'CPANEL_LIST_CLUSTER_TOOLS',
  LIST_CLUSTERS_AOS_VERSIONS = 'CPANEL_LIST_CLUSTERS_AOS_VERSIONS',
  LIST_CLUSTERS_COMPATIBILITY_MATRIX = 'CPANEL_LIST_CLUSTERS_COMPATIBILITY_MATRIX',
  NOTIFICATIONS = 'CPANEL_NOTIFICATIONS',
  ORGANIZATION = 'CPANEL_ORGANIZATION',
  ORGANIZATION_ADMIN = 'CPANEL_ORGANIZATION_ADMIN',
  ORGANIZATION_ANALYTICS = 'CPANEL_ORGANIZATION_ANALYTICS',
  ORGANIZATION_ANONYMOUS_ACCESS_PROVIDERS = 'CPANEL_ORGANIZATION_ANONYMOUS_ACCESS_PROVIDERS',
  ORGANIZATION_API_AUTHORIZATION = 'CPANEL_ORGANIZATION_API_AUTHORIZATION',
  ORGANIZATION_AUDIT_TRAIL = 'CPANEL_ORGANIZATION_AUDIT_TRAIL',
  ORGANIZATION_AUDIT_TRAILS = 'CPANEL_ORGANIZATION_AUDIT_TRAILS',
  ORGANIZATION_AUTHENTICATION_SETTINGS = 'CPANEL_ORGANIZATION_AUTHENTICATION_SETTINGS',
  ORGANIZATION_AUTHORIZATION_RULE = 'CPANEL_ORGANIZATION_AUTHORIZATION_RULE',
  ORGANIZATION_AUTHORIZATION_RULES = 'CPANEL_ORGANIZATION_AUTHORIZATION_RULES',
  ORGANIZATION_CLOUD_SERVICES = 'CPANEL_ORGANIZATION_CLOUD_SERVICES',
  ORGANIZATION_DISK_VOLUME_USAGE = 'CPANEL_ORGANIZATION_DISK_VOLUME_USAGE',
  ORGANIZATION_GOOGLE_AUTHORIZATION = 'CPANEL_ORGANIZATION_GOOGLE_AUTHORIZATION',
  ORGANIZATION_LIST_API_AUTHORIZATION = 'CPANEL_ORGANIZATION_LIST_API_AUTHORIZATION',
  ORGANIZATION_MY_NUTANIX_AUTHORIZATION = 'CPANEL_ORGANIZATION_MY_NUTANIX_AUTHORIZATION',
  ORGANIZATION_NOTIFICATION_CENTER = 'CPANEL_ORGANIZATION_NOTIFICATION_CENTER',
  ORGANIZATION_NOTIFICATION_CENTER_SETTINGS = 'CPANEL_ORGANIZATION_NOTIFICATION_CENTER_SETTINGS',
  ORGANIZATION_ROLE_SCOPES = 'CPANEL_ORGANIZATION_ROLE_SCOPES',
  ORGANIZATION_ROLES = 'CPANEL_ORGANIZATION_ROLES',
  ORGANIZATION_SAML_PROVIDERS = 'CPANEL_ORGANIZATION_SAML_PROVIDERS',
  ORGANIZATION_USAGE = 'CPANEL_ORGANIZATION_USAGE',
  ORGANIZATION_USER = 'CPANEL_ORGANIZATION_USER',
  ORGANIZATION_USER_ACTIVITY = 'CPANEL_ORGANIZATION_USER_ACTIVITY',
  ORGANIZATION_USERS = 'CPANEL_ORGANIZATION_USERS',
  PENDING_REQUEST = 'CPANEL_PENDING_REQUEST',
  RECONNECT_CUSTOMER_CLOUD_SERVICES = 'CPANEL_MUTATION_RECONNECT_CUSTOMER_CLOUD_SERVICES',
  RECONNECT_ORGANIZATION_CLOUD_SERVICES = 'CPANEL_MUTATION_RECONNECT_ORGANIZATION_CLOUD_SERVICES',
  REMOVE_APP_FROM_FOLDER = 'CPANEL_MUTATION_REMOVE_APP_FROM_FOLDER',
  REMOVE_INSTANCE_TYPE_CUSTOMER_CLOUD_SERVICES = 'CPANEL_MUTATION_REMOVE_INSTANCE_TYPE_CUSTOMER_CLOUD_SERVICES',
  REMOVE_INSTANCE_TYPE_ORGANIZATION_CLOUD_SERVICES = 'CPANEL_MUTATION_REMOVE_INSTANCE_TYPE_ORGANIZATION_CLOUD_SERVICES',
  RENAME_FOLDER = 'CPANEL_MUTATION_RENAME_FOLDER',
  RENAME_UTILITY_POOL = 'CPANEL_MUTATION_RENAME_UTILITY_POOL',
  RESEND_USER_INVITATION = 'CPANEL_MUTATION_RESEND_USER_INVITATION',
  RESET_ACCOUNT_WITH_DEFAULT_MACHINE_IMAGE = 'CPANEL_MUTATION_RESET_ACCOUNT_WITH_DEFAULT_MACHINE_IMAGE',
  RESET_USER_PASSWORD = 'CPANEL_MUTATION_RESET_USER_PASSWORD',
  RESTORE_BACKUP = 'CPANEL_MUTATION_RESTORE_BACKUP',
  RESTORE_PERSISTENT_DESKTOP_BACKUP = 'CPANEL_MUTATION_RESTORE_PERSISTENT_DESKTOP_BACKUP',
  RESTORE_USER_VOLUME_BACKUP = 'CPANEL_MUTATION_RESTORE_USER_VOLUME_BACKUP',
  RESUME_CLUSTER = 'CPANEL_MUTATION_RESUME_CLUSTER',
  REVOKE_USER_INVITATION = 'CPANEL_MUTATION_REVOKE_USER_INVITATION',
  SET_MY_NUTANIX_AUTHORIZATION_RULE = 'CPANEL_MUTATION_SET_MY_NUTANIX_AUTHORIZATION_RULE',
  SUSPEND_SERVER = 'CPANEL_MUTATION_SUSPEND_SERVER',
  SUPPORT_TOOL_USER = 'CPANEL_SUPPORT_TOOL_USER',
  TASK = 'CPANEL_TASK',
  TASK_ADDITIONAL_INFO = 'CPANEL_ADDITIONAL_TASK_INFO',
  TASKS = 'CPANEL_TASKS',
  UPDATE_PERSISTENT_DESKTOP_INSTANCE_TYPE = 'CPANEL_MUTATION_UPDATE_PERSISTENT_DESKTOP_POOL_INSTANCE_TYPE',
  UNDELETE_APPLICATION_BEFORE_PUBLISH = 'CPANEL_MUTATION_UNDELETE_APPLICATION_BEFORE_PUBLISH',
  UPDATE_ACCOUNT = 'CPANEL_MUTATION_UPDATE_ACCOUNT',
  UPDATE_ACCOUNT_ANONYMOUS_ACCESS_PROVIDERS = 'CPANEL_MUTATION_UPDATE_ACCOUNT_ANONYMOUS_ACCESS_PROVIDERS',
  UPDATE_ACCOUNT_API_AUTHORIZATION = 'CPANEL_MUTATION_UPDATE_ACCOUNT_API_AUTHORIZATION',
  UPDATE_ACCOUNT_AUTHENTICATION_SETTINGS = 'CPANEL_MUTATION_UPDATE_ACCOUNT_AUTHENTICATION_SETTINGS',
  UPDATE_ACCOUNT_GOOGLE_AUTHORIZATION = 'CPANEL_MUTATION_UPDATE_ACCOUNT_GOOGLE_AUTHORIZATION',
  UPDATE_ACCOUNT_MY_NUTANIX_AUTHORIZATION = 'CPANEL_MUTATION_UPDATE_ACCOUNT_MY_NUTANIX_AUTHORIZATION',
  ACCOUNT_NETWORKING_SETTINGS = 'CPANEL_ACCOUNT_NETWORKING_SETTINGS',
  ACCOUNT_PROFILE_SETTINGS = 'CPANEL_ACCOUNT_PROFILE_SETTINGS',
  UPDATE_ACCOUNT_PROFILE_SETTINGS = 'CPANEL_MUTATION_UPDATE_ACCOUNT_PROFILE_SETTINGS',
  UPDATE_ACCOUNT_RESIZE_RULE_SETTINGS = 'CPANEL_MUTATION_UPDATE_ACCOUNT_RESIZE_RULE_SETTINGS',
  UPDATE_ACCOUNT_SAML_PROVIDERS = 'CPANEL_MUTATION_UPDATE_ACCOUNT_SAML_PROVIDERS',
  UPDATE_ACCOUNT_USER = 'CPANEL_MUTATION_UPDATE_ACCOUNT_USER',
  UPDATE_ACCOUNT_USER_PERSONAL_DRIVE_SETTINGS = 'CPANEL_MUTATION_UPDATE_ACCOUNT_USER_PERSONAL_DRIVE_SETTINGS',
  UPDATE_ALLOWED_IPS = 'CPANEL_MUTATION_UPDATE_ALLOWED_IPS',
  UPDATE_ANONYMOUS_ACCESS_PROVIDER = 'UPDATE_MUTATION_ANONYMOUS_ACCESS_PROVIDER',
  UPDATE_API_AUTHORIZATION = 'CPANEL_MUTATION_UPDATE_API_AUTHORIZATION',
  UPDATE_APPLICATION = 'CPANEL_MUTATION_UPDATE_APPLICATION',
  UPDATE_APPLICATION_ON_PUBLISH = 'CPANEL_MUTATION_UPDATE_APPLICATION_ON_PUBLISH',
  UPDATE_AUTHORIZATION_RULE = 'CPANEL_MUTATION_UPDATE_AUTHORIZATION_RULE',
  UPDATE_AUTO_TERMINATION_TIME = 'CPANEL_MUTATION_UPDATE_AUTO_TERMINATION_TIME',
  UPDATE_CLUSTER_ACCESS_POLICY = 'CPANEL_MUTATION_UPDATE_CLUSTER_ACCESS_POLICY',
  UPDATE_CLUSTER_AOS_TIER = 'CPANEL_MUTATION_UPDATE_CLUSTER_AOS_TIER',
  UPDATE_CLUSTER_CAPACITY_SETTINGS = 'CPANEL_MUTATION_UPDATE_CLUSTER_CAPACITY_SETTINGS',
  UPDATE_CLUSTER_KEY_NAME = 'CPANEL_MUTATION_UPDATE_CLUSTER_KEY_NAME',
  UPDATE_CLUSTER_LICENCING_INFO = 'CPANEL_MUTATION_UPDATE_CLUSTER_LICENCING_INFO',
  UPDATE_CLUSTER_RESOURCE_TAGS = 'CPANEL_MUTATION_UPDATE_CLUSTER_RESOURCE_TAGS',
  UPDATE_CLUSTER_TOOLS = 'CPANEL_UPDATE_CLUSTER_TOOLS',
  UPDATE_CUSTOMER = 'CPANEL_MUTATION_UPDATE_CUSTOMER',
  UPDATE_CUSTOMER_ANONYMOUS_ACCESS_PROVIDERS = 'CPANEL_MUTATION_UPDATE_CUSTOMER_ANONYMOUS_ACCESS_PROVIDERS',
  UPDATE_CUSTOMER_API_AUTHORIZATION = 'CPANEL_MUTATION_UPDATE_CUSTOMER_API_AUTHORIZATION',
  UPDATE_CUSTOMER_AUTHENTICATION_SETTINGS = 'CPANEL_MUTATION_UPDATE_CUSTOMER_AUTHENTICATION_SETTINGS',
  UPDATE_CUSTOMER_AVAILABLE_APPLICATIONS = 'CPANEL_MUTATION_UPDATE_CUSTOMER_AVAILABLE_APPLICATIONS',
  UPDATE_CUSTOMER_BILLING_SUBSCRIPTIONS = 'CPANEL_MUTATION_UPDATE_CUSTOMER_BILLING_SUBSCRIPTIONS',
  UPDATE_CUSTOMER_EXTRA_FEAUTRES = 'CPANEL_MUTATION_UPDATE_CUSTOMER_EXTRA_FEAUTRES',
  UPDATE_CUSTOMER_GOOGLE_AUTHORIZATION = 'CPANEL_MUTATION_UPDATE_CUSTOMER_GOOGLE_AUTHORIZATION',
  UPDATE_CUSTOMER_LIMITS = 'CPANEL_MUTATION_UPDATE_CUSTOMER_LIMITS',
  UPDATE_CUSTOMER_MY_NUTANIX_AUTHORIZATION = 'CPANEL_MUTATION_UPDATE_CUSTOMER_MY_NUTANIX_AUTHORIZATION',
  UPDATE_CUSTOMER_SAML_PROVIDERS = 'CPANEL_MUTATION_UPDATE_CUSTOMER_SAML_PROVIDERS',
  UPDATE_CUSTOMER_SUPPORT_SETTINGS = 'CPANEL_MUTATION_UPDATE_CUSTOMER_SUPPORT_SETTINGS',
  UPDATE_CUSTOMER_USER = 'CPANEL_MUTATION_UPDATE_CUSTOMER_USER',
  UPDATE_DOMAIN_JOIN_SETTINGS = 'CPANEL_MUTATION_UPDATE_DOMAIN_JOIN_SETTINGS',
  UPDATE_GOOGLE_AUTHORIZATION_RULE = 'CPANEL_MUTATION_UPDATE_GOOGLE_AUTHORIZATION_RULE',
  UPDATE_ORGANIZATION = 'CPANEL_MUTATION_UPDATE_ORGANIZATION',
  UPDATE_ORGANIZATION_ANONYMOUS_ACCESS_PROVIDERS = 'CPANEL_MUTATION_UPDATE_ORGANIZATION_ANONYMOUS_ACCESS_PROVIDERS',
  UPDATE_ORGANIZATION_API_AUTHORIZATION = 'CPANEL_MUTATION_UPDATE_ORGANIZATION_API_AUTHORIZATION',
  UPDATE_ORGANIZATION_AUTHENTICATION_SETTINGS = 'CPANEL_MUTATION_UPDATE_ORGANIZATION_AUTHENTICATION_SETTINGS',
  UPDATE_ORGANIZATION_GOOGLE_AUTHORIZATION = 'CPANEL_MUTATION_UPDATE_ORGANIZATION_GOOGLE_AUTHORIZATION',
  UPDATE_ORGANIZATION_MY_NUTANIX_AUTHORIZATION = 'CPANEL_MUTATION_UPDATE_ORGANIZATION_MY_NUTANIX_AUTHORIZATION',
  UPDATE_ORGANIZATION_SAML_PROVIDERS = 'CPANEL_MUTATION_UPDATE_ORGANIZATION_SAML_PROVIDERS',
  UPDATE_ORGANIZATION_USER = 'CPANEL_MUTATION_UPDATE_ORGANIZATION_USER',
  UPDATE_SAML_IDENTITY_PROVIDER = 'CPANEL_MUTATION_UPDATE_SAML_IDENTITY_PROVIDER',
  UPDATE_TASK_STATUS = 'CPANEL_MUTATION_UPDATE_TASK_STATUS',
  UPDATE_TERMS_OF_SERVICE = 'CPANEL_MUTATION_UPDATE_TERMS_OF_SERVICE',
  UPDATE_USER_VOLUME_BACKUP_SETTINGS = 'CPANEL_MUTATION_UPDATE_USER_VOLUME_BACKUP_SETTINGS',
  UPDATE_USER_VOLUMES_SETTINGS = 'CPANEL_MUTATION_UPDATE_USER_VOLUMES_SETTINGS',
  USERS = 'CPANEL_USERS',
  VALIDATE_CLUSTER_VPC = 'CPANEL_MUTATION_VALIDATE_CLUSTER_VPC',
  VERIFY_AZURE_CREDENTIALS_TEMPLATE = 'CPANEL_MUTATION_VERIFY_AZURE_CREDENTIALS_TEMPLATE',
  VERIFY_CLOUD_FORMATION_TEMPLATE = 'CPANEL_MUTATION_VERIFY_CLOUD_FORMATION_TEMPLATE',
  VERIFY_CLOUD_PROJECT_ID = 'CPANEL_MUTATION_VERIFY_CLOUD_PROJECT_ID',
  VERIFY_GCP_CREDENTIALS = 'CPANEL_MUTATION_VERIFY_GCP_CREDENTIALS',
  ACCOUNT_SUMMARY = 'CPANEL_ACCOUNT_SUMMARY',
  ACCOUNT_SETTINGS = 'CPANEL_ACCOUNT_SETTINGS',
  TEST_GUEST_AGENT_MIGRATION = 'CPANEL_MUTATION_TEST_GUEST_AGENT_MIGRATION',
  MIGRATE_GUEST_AGENT = 'CPANEL_MUTATION_MIGRATE_GUEST_AGENT',
  ACCOUNT_AUTO_TERMINATION = 'CPANEL_ACCOUNT_AUTO_TERMINATION',
  CPANEL_WEBRTC_PRIVATE_NETWORK = 'CPANEL_WEBRTC_PRIVATE_NETWORK',
  CPANEL_OVERRIDE_FORCE_NEW_APP_MODE = 'CPANEL_OVERRIDE_FORCE_NEW_APP_MODE',
  OPEN_CLUSTER_SSH_TUNNEL = 'CPANEL_MUTATION_OPEN_CLUSTER_SSH_TUNNEL',
  EXTEND_CLUSTER_SSH_TUNNEL = 'CPANEL_MUTATION_EXTEND_CLUSTER_SSH_TUNNEL',
  CLOSE_CLUSTER_SSH_TUNNEL = 'CPANEL_MUTATION_CLOSE_CLUSTER_SSH_TUNNEL',
  UPGRADE_CLUSTER_FGW = 'CPANEL_MUTATION_UPGRADE_CLUSTER_FGW',
  CPANEL_LIST_CUSTOMER_CLOUD_SERVICE_SUBNETS = 'CPANEL_LIST_CUSTOMER_CLOUD_SERVICE_SUBNETS',
  CPANEL_LIST_ORGANIZATION_CLOUD_SERVICE_SUBNETS = 'CPANEL_LIST_ORGANIZATION_CLOUD_SERVICE_SUBNETS',
}

export default Permissions;
